module.exports = __webpack_public_path__ + "d1f1ac058674dfca1b0db0a155afb0c2.pdf";